export enum PostMessageType {
  QuotationCompleted = 'quotationCompleted',
}

export function postMessageToParent(messageType: PostMessageType) {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage(messageType, '*')
  }
}
